export default "__VITE_ASSET__CesJjCW7__"